export const ru = {
    'be-sure-no-error': 'Для просмотра этой страницы нет прав',
    title: 'Страница недоступна'
};
